import i18next from "i18next";

export const validateLeagueName = (e: HTMLInputElement | HTMLTextAreaElement) => {
	const value = e.value;
	let error = "";

	if (!value) {
		error = i18next.t("create_league.form.no_value");
	} else if (value.length < 3) {
		error = i18next.t("create_league.form.short_value");
	} else if (value.length > 40) {
		error = i18next.t("create_league.form.long_value");
	} else if (!value.match(/^[A-Za-z0-9][A-Za-z0-9\s]{1,}[A-Za-z0-9]$/)) {
		error = i18next.t("create_league.form.invalid_format");
	}

	if (error.length) {
		return error;
	}

	return null;
};
